import React from "react";
import "./About.css";

const About = () => {
  return (
    <>
      <div className="containerAbout">
        <div className="about">
          <h2>Who i am</h2>
          <p className="textAbout">
            Hi, I'm Leontine, welcome to my portfolio. It's definitely a work in
            progress. Follow me on my journey as I learn and develop. I just
            recently graduated from the web development program at TechGrounds
            and wish to continue my development as a frontender. My goal is to
            perfect my knowledge of HTML, CSS, Vanilla Javascript, React and
            Redux, and to learn even more. I like to make my work look visually
            appealing and have discovered my creative side. I want to make
            things that look amazing! As a person, I am soft spoken and soft
            hearted. I love a bit of humor, cute cats, delicious coffee and
            original flavors jelly beans!
          </p>
          <img className="photoAbout" src="me.jpg" alt="myself" />
        </div>
      </div>
    </>
  );
};

export default About;
